import type { MouseEventHandler } from 'react';
import { SparkIcon } from '../SparkIcon';
import './TagPill.css';

export type TagPillVariant = 'default' | 'warning';

/** Minimal rounded pill tag displaying a short label. */
export type TagPillProps = {
  label?: string;
  variant?: TagPillVariant;
  /** Decorative icon after the label (16px). */
  endIconSlug?: string;
  /** When set, the pill is a button (Figma Tag-Pill + info). */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Accessible name when `onClick` is set. Defaults to `label`. */
  'aria-label'?: string;
  className?: string;
};

export function TagPill({
  label = 'Tag',
  variant = 'default',
  endIconSlug,
  onClick,
  'aria-label': ariaLabel,
  className = '',
}: TagPillProps) {
  const classNames = [
    'spark-tag-pill',
    variant !== 'default' ? `spark-tag-pill-${variant}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {label}
      {endIconSlug ? <SparkIcon slug={endIconSlug} size="small" className="spark-tag-pill-icon" /> : null}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={classNames} aria-label={ariaLabel || label} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <span className={classNames}>{content}</span>;
}
